<template>
    <Page withNavbar withNavigation>
        <main>
            <SectionTitle :title="config.PROFILE_PRIVACY_TITLE"/>
            <SectionText :text="config.PROFILE_EDIT_DELETE"/>
            <SectionActions>
                <Button :color="config.COLOR_PRIMARY" flat @click="onSubmit">
                    {{ config.PROFILE_EDIT_DELETE_CTA }}
                </Button>
            </SectionActions>
        </main>
        <!-- Modals -->
        <transition name="fade">
            <ModalProfileDelete
                v-if="modals.delete"
                @close="onDeleteClose"
                @done="onDeleteDone"
            />
        </transition>
    </page>
</template>
<script>
import { SolutionConsumer, UserConsumer } from '../../mixins';
import { Page, ModalProfileDelete } from '../../components/mobile';
import { SectionTitle, SectionText, SectionActions } from '../../components/shared';

export default {
    name: 'ProfilePrivacy',
    components: {
        Page, ModalProfileDelete, SectionTitle, SectionText, SectionActions,
    },
    mixins: [SolutionConsumer, UserConsumer],
    data () {
        return {
            modals: {
                delete: false,
            },
        };
    },
    methods: {
        onSubmit () {
            this.modals.delete = true;
        },
        onDeleteClose () {
            this.modals.delete = false;
        },
        async onDeleteDone () {
            try {
                this.modals.delete = false;
            } catch (err) {
                console.log(err);
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';

main {
    @include container(40px 20px);
}
</style>
